import SearchBox from 'main/components/tables/interactive/components/search_box/SearchBox';

export default SearchBox;
